import React, { useMemo, useState, useEffect } from 'react';
import StickyTitle from '../components/StickyTitle.js';
import { MaterialReactTable } from 'material-react-table';
import { Box, Button, IconButton } from '@mui/material';
import axios from 'axios';
import { CSVLink } from "react-csv";
import { useAuth } from '../../AuthContext.js';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DebitForm from '../components/DebitForm.js';
import CreditDebitPreview from "../components/CreditDebitPreview.js"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DebitnotePage = () => {

  const [isNewDebitFormOpen, setIsNewDebitFormOpen] = useState(false);

  const openNewDebitForm = () => {
    setIsNewDebitFormOpen(true);
  };

  const closeNewDebitForm = () => {
    setIsNewDebitFormOpen(false);
  };
  let [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowDataPreview, setSelectedRowDataPreview] = useState();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [data, setData] = useState([]);
  const { userRole } = useAuth()
  const [employee, setEmployee] = useState(true);

  useEffect(() => {
    if (userRole === "manager") {
      setEmployee(false)
    } else {
      setEmployee(true)
    };
  }, [userRole])


  const delete_Debit = async (id) => {
    try {
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/debits/del_debit`, {
        data: {
          id: id
        }
      });
      if (response.data.success) {
        toast.success(`Debit Note with id: ${id} deleted successfully.`);
      } else {
        toast.error("Error deleting Debit Note");
      }
    } catch (error) {
      toast.error("Error deleting Debit Note");
    }
  };



  useEffect(() => {
    const fetch_Debits = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/debits/all_debits`);
        const responseData = await response.json();
        if (responseData) {
          setData(responseData.debit);
        }
      } catch (error) {
        // Handle errors here
        console.error("Error fetching data:", error);
      }
    }
    fetch_Debits();
  }, [isNewDebitFormOpen])


  const columns = useMemo(
    () => [
      {
        accessorKey: 'id', //access nested data with dot notation
        header: 'debitId',
        size: 100,
      },
      {
        accessorKey: 'vendorid', //access nested data with dot notation
        header: 'Vendor Id',
        size: 100,
      },
      {
        accessorKey: 'vendorname', //access nested data with dot notation
        header: 'Vendor Name',
        size: 100,
      },
      {
        accessorKey: 'vendorphone',
        header: 'Vendor Phone',
        size: 100,
      },
      {
        accessorKey: 'vendoraddress', //normal accessorKey
        header: 'Vendor Address',
        size: 200,
      },
      {
        accessorKey: 'amount', //normal accessorKey
        header: 'Amount',
        size: 200,
      },
      {
        accessorKey: 'date',
        header: 'Date',
        size: 100,
      },
      {
        accessorKey: 'description',
        header: 'Description',
        size: 100,
      },
      {
        accessorKey: 'lponumber',
        header: 'Vendor LPO',
        size: 100,
      }
    ],
    [],
  );


  return (
    <>
      <StickyTitle title="Debit Note" button_action={openNewDebitForm} button="New debit note" />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className=' px-4 lg:px-5 py-4 lg:py-10 flex flex-col gap-0 overflow-x-auto'>
        <div className="table-filters flex flex-row items-center justify-between mt-3 mb-3">
          <div className='text-2xl ml-5 font-bold font-poppins flex items-center'>All Debit Notes<button onClick={openNewDebitForm} className='px-3 py-0 text-3xl rounded bg-[#37a703] text-white font-bold font-poppins ml-2 sm:block hidden'>+</button></div>
          <DebitForm isOpen={isNewDebitFormOpen} onClose={closeNewDebitForm} />
        </div>

        {data ? (<div className="w-full">
          <MaterialReactTable
            enableRowActions
            enableRowSelection
            columns={columns}
            data={data}
            renderRowActions={({ row }) => (
              <Box>
                <IconButton onClick={() => {
                  let rowData = row.original;
                  setSelectedRowDataPreview(rowData)
                  setIsPopupOpen(true);
                }}>
                  <ReceiptIcon />
                </IconButton>
              </Box>
            )}
            renderTopToolbarCustomActions={({ table }) => {
              const handleDelete = () => {
                const selectedRows = table.getSelectedRowModel().flatRows;

                if (selectedRows.length === 1) {
                  selectedRow = selectedRows[0];
                  const selectedRowId = selectedRow.original.id;
                  setSelectedRow(selectedRow);
                  alert('Deleting debit with ID: ' + selectedRowId);
                  delete_Debit(selectedRowId)

                } else {
                  alert('Please select a single row to delete.');
                }
              };
              // const handleEdit = () => {
              //   const selectedRows = table.getSelectedRowModel().flatRows;

              //   if (selectedRows.length === 1) {
              //     const selectedRow = selectedRows[0];
              //     selectedRowData = selectedRow.original;
              //     setSelectedRowData(selectedRowData);
              //     setisNewDebitFormOpen(true); // Open the form
              //   } else {
              //     alert('Please select a single row to Edit.');
              //   }
              // };


              return (
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <Button
                    color="error"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleDelete}
                    variant="contained"
                    sx={employee ? { display: 'none' } : {}}

                  >
                    Delete
                  </Button>
                  {/* <Button
                    color="success"
                    disabled={!table.getIsSomeRowsSelected()}
                    onClick={handleEdit}
                    variant="contained"
                    sx={employee ? { display: 'none' } : {}}

                  >
                    Edit
                  </Button> */}
                  <Button
                    color="success"
                    variant="contained"
                  >
                    <CSVLink data={data}>Export to CSV</CSVLink>
                  </Button>
                </div>
              );
            }}
          />
        </div>) : (null)}
      </div>

      <div>
        {isPopupOpen && (
          <div style={{
            display: isPopupOpen ? 'block' : 'none',
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            padding: '20px',
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
            zIndex: '999',
            height: '90vh',
            overflowY: 'auto',
            width: '800px'
          }}>

            <button
              className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 bg-transparent border-5 border-black"
              onClick={() => setIsPopupOpen(false)}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <CreditDebitPreview
              debitNote={true}
              creditNote={false}
              clientaddress={selectedRowDataPreview.vendoraddress}
              clientname={selectedRowDataPreview.vendorname}
              description={selectedRowDataPreview.description}
              debitAmount={selectedRowDataPreview.amount}
              creditAmount={selectedRowDataPreview.amount}
              date={selectedRowDataPreview.date}
            />

          </div>
        )}
      </div>

    </>
  );
};

export default DebitnotePage;
